import { useCallback, useEffect, useRef } from 'react';
import { utworzNajazdKarty, type NajazdKarty } from '@/lib/najazdKarty';

/**
 * Podpięcie `utworzNajazdKarty` (src/lib/najazdKarty.ts) pod okno: przewijanie i kółko myszy
 * blokują, ruch myszy (faza przechwytywania, przed obsługą karty) odblokowuje. Zwraca stabilny
 * `naNajazd(id | null)` dla `SourcePostCard.onHover` (memo kart się nie psuje).
 */
export function useNajazdKarty(ustaw: (id: string | null) => void): (id: string | null) => void {
  const ref = useRef<NajazdKarty | null>(null);
  if (ref.current == null) ref.current = utworzNajazdKarty(ustaw);

  useEffect(() => {
    const n = ref.current!;
    const przewiniecie = () => n.przewiniecie();
    const ruch = (e: MouseEvent) => n.ruchMyszy(e.clientX, e.clientY);
    const opcje = { capture: true, passive: true } as const;
    window.addEventListener('scroll', przewiniecie, opcje);
    window.addEventListener('wheel', przewiniecie, opcje);
    window.addEventListener('mousemove', ruch, opcje);
    return () => {
      window.removeEventListener('scroll', przewiniecie, opcje);
      window.removeEventListener('wheel', przewiniecie, opcje);
      window.removeEventListener('mousemove', ruch, opcje);
      n.zniszcz();
    };
  }, []);

  return useCallback((id: string | null) => {
    if (id) ref.current!.najazd(id);
    else ref.current!.zjazd();
  }, []);
}
